<div class="container">
  <div class="row">
    <div class="col-12 mb-4">
      <label><b> Customer Portfolio Data Report</b> </label>
      <form #form="ngForm" [formGroup]="portfolioDataForm" (ngSubmit)="submitFormData(form, 'portfolio')">
        <div class="row d-flex align-items-end">
          <div class="col-md-3">
            <label>Date</label>
            <input
              class="form-control"
              formControlName="date"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [maxDate]="maxDate"
            />
            <errors [on]="(form.submitted || portfolioDataForm.get('date').touched) && portfolioDataForm.get('date').invalid">
              Required
            </errors>
          </div>
          <div class="offset-md-3 col-md-3">
            <button
              [disabled]="downloadingReport"
              class="mt-2 ws-loading {{ selectType === 'portfolio' && downloadingReport ? 'ws-loading-progress' : '' }}"
              type="submit"
            >
              Download
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <errors [on]="selectType === 'portfolio' && errorMessage">{{ errorMessage }}</errors>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mb-4">
      <label>
        <b>Customer Confirmation Note</b>
      </label>
      <form #confirmForm="ngForm" [formGroup]="confirmationNoteForm" (ngSubmit)="submitFormData(confirmForm, 'confirmation')">
        <div class="row d-flex align-items-end">
          <div class="col-md-3">
            <label>From Date</label>
            <input
              class="form-control"
              formControlName="fromDate"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [maxDate]="maxDate"
            />
            <errors
              [on]="(confirmForm.submitted || confirmationNoteForm.get('fromDate').touched) && confirmationNoteForm.get('fromDate').invalid"
            >
              Required
            </errors>
          </div>

          <div class="col-md-3">
            <label>To Date</label>
            <input
              class="form-control"
              formControlName="toDate"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [minDate]="confirmationNoteForm.get('fromDate').value"
              [maxDate]="maxDate"
            />
            <errors
              [on]="(confirmForm.submitted || confirmationNoteForm.get('toDate').touched) && confirmationNoteForm.get('toDate').invalid"
            >
              Required
            </errors>
          </div>

          <div class="col-md-3">
            <button
              [disabled]="downloadingReport"
              class="mt-2 ws-loading {{ selectType === 'confirmation' && downloadingReport ? 'ws-loading-progress' : '' }}"
              type="submit"
            >
              Download
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <errors [on]="selectType === 'confirmation' && invalidDateRange">{{ invalidDateRange }}</errors>
            <errors [on]="selectType === 'confirmation' && errorMessage">{{ errorMessage }}</errors>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mb-4">
      <label>
        <b>Customer Ledger Statement</b>
      </label>
      <form #ledgerForm="ngForm" [formGroup]="ledgerStatementForm" (ngSubmit)="submitFormData(ledgerForm, 'ledger')">
        <div class="row d-flex align-items-end">
          <div class="col-md-3">
            <label>From Date</label>
            <input
              class="form-control"
              formControlName="fromDate"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [maxDate]="maxDate"
            />
            <errors
              [on]="(ledgerForm.submitted || ledgerStatementForm.get('fromDate').touched) && ledgerStatementForm.get('fromDate').invalid"
            >
              Required
            </errors>
          </div>

          <div class="col-md-3">
            <label>To Date</label>
            <input
              class="form-control"
              formControlName="toDate"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [minDate]="ledgerStatementForm.get('fromDate').value"
              [maxDate]="maxDate"
            />
            <errors [on]="(ledgerForm.submitted || ledgerStatementForm.get('toDate').touched) && ledgerStatementForm.get('toDate').invalid">
              Required
            </errors>
          </div>

          <div class="col-md-3">
            <button
              [disabled]="downloadingReport"
              class="mt-2 ws-loading {{ selectType === 'ledger' && downloadingReport ? 'ws-loading-progress' : '' }}"
              type="submit"
            >
              Download
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <errors [on]="selectType === 'ledger' && invalidDateRange">{{ invalidDateRange }}</errors>
            <errors [on]="selectType === 'ledger' && errorMessage">{{ errorMessage }}</errors>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mb-4">
      <label>
        <b>Customer Tax Certificate</b>
      </label>
      <form #taxForm="ngForm" [formGroup]="taxCertificateForm" (ngSubmit)="submitFormData(taxForm, 'tax')">
        <div class="row d-flex align-items-end">
          <div class="col-md-3">
            <label>From Date</label>
            <input
              class="form-control"
              formControlName="fromDate"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [maxDate]="maxDate"
            />
            <errors [on]="(taxForm.submitted || taxCertificateForm.get('fromDate').touched) && taxCertificateForm.get('fromDate').invalid">
              Required
            </errors>
          </div>

          <div class="col-md-3">
            <label>To Date</label>
            <input
              class="form-control"
              formControlName="toDate"
              bsDatepicker
              [bsConfig]="{
                containerClass: 'theme-dark-blue',
                dateInputFormat: 'YYYY-MM-DD',
                showWeekNumbers: false,
                customTodayClass: 'today'
              }"
              [minDate]="taxCertificateForm.get('fromDate').value"
              [maxDate]="maxDate"
            />
            <errors [on]="(taxForm.submitted || taxCertificateForm.get('toDate').touched) && taxCertificateForm.get('toDate').invalid">
              Required
            </errors>
          </div>

          <div class="col-md-3">
            <button
              [disabled]="downloadingReport"
              class="mt-2 ws-loading {{ selectType === 'tax' && downloadingReport ? 'ws-loading-progress' : '' }}"
              type="submit"
            >
              Download
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <errors [on]="selectType === 'tax' && invalidDateRange">{{ invalidDateRange }}</errors>
            <errors [on]="selectType === 'tax' && errorMessage">{{ errorMessage }}</errors>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
